// @ts-check

import { createHumanState, nextHumanStep } from "./human-solver.js";

export function createHint(input) {
  const result = nextHumanStep(createHumanState(input));
  if (!result) return null;
  return {
    ...result,
    stages: [
      { id: "region", text: regionText(result) },
      {
        id: "evidence",
        text: `Look at the highlighted ${result.evidence.unit_type ?? "cells"}.`,
      },
      { id: "pattern", text: techniqueText(result.technique) },
      { id: "result", text: resultText(result) },
      { id: "apply", text: "Apply this logical step when you are ready." },
    ],
  };
}

function regionText(step) {
  if (step.evidence.unit_type)
    return `Focus on ${step.evidence.unit_type} ${Number(step.evidence.unit_index) + 1}.`;
  return "Focus on the highlighted pattern.";
}

function techniqueText(technique) {
  return (
    {
      naked_single: "Only one candidate can fit this cell.",
      hidden_single: "This digit has only one possible cell in the region.",
      locked_candidate:
        "This candidate is locked to one line within the region.",
      naked_pair: "Two cells share the same two candidates.",
      hidden_pair: "Two digits can occur only in these two cells.",
      naked_triple: "Three cells are restricted to the same three candidates.",
      hidden_triple: "Three digits are restricted to these three cells.",
      x_wing: "Two matching candidate lines form an X-Wing.",
    }[technique] ?? "A logical deduction is available."
  );
}

function resultText(step) {
  if (step.placements.length) {
    const placement = step.placements[0];
    return `Place ${placement.digit} in row ${Math.floor(placement.cell / 9) + 1}, column ${(placement.cell % 9) + 1}.`;
  }
  return `Remove ${step.eliminations.length} candidate${step.eliminations.length === 1 ? "" : "s"} from the highlighted cells.`;
}
